import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {ContentHeader, Loader} from '@components';
import Select from 'react-select';
import {Link} from 'react-router-dom';
import {useFormik} from 'formik';
import {useNavigate, useParams} from 'react-router-dom';
import makeAnimated from 'react-select/animated';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {toast} from 'react-toastify';
import ViewDocFile from './ViewDocFile';
import {Button, Modal} from 'react-bootstrap';
import Editor from '../../components/text-editor';
import {uploadImage} from '../../services/auth';
import {
  fileDeleteHandler,
  getDocInfo,
  updateDoc,
  getDocFiles,
  createDocument
} from '../../services/docs';
import handleStatus from '../../utils/ajax';
import {logoutUser} from '@app/store/reducers/auth';
import {getAllProjectNames} from '../../services/project';
import {MdOutlineClose, MdImage, MdGif, MdAudioFile} from 'react-icons/md';
import {
  BsFiletypeDocx,
  BsFileZip,
  BsFiletypeCsv,
  BsFileExcel
} from 'react-icons/bs';
import {TbPdf} from 'react-icons/tb';

const animatedComponents = makeAnimated();

const UpdateDoc = () => {
  const [docContent, setDocContent] = React.useState('');
  const [showLoader, setShowLoader] = useState(false);
  const [allProject, setAllProject] = React.useState([]);
  const [project, setProject] = React.useState({});
  const [selectedProject, setSelectedProject] = useState({});
  const [docName, setDocName] = React.useState('');
  const [show, setShow] = useState(false);
  const [activeLink, setActiveLink] = useState('');
  const [file, setFile] = useState(null);
  const [hash, setHash] = useState('');
  const [uploaded, setUploaded] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [doc, setDoc] = React.useState({});
  const [reload, setReload] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {docId} = useParams();

  

  function ModalPopup({setHash}) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleClose = () => {
      setShow(false);
      setActiveLink('');
      // setHash('');
    };

    const uploadDoc = async (e: any) => {
      const file = e.target.files[0];
      if (file) {
        setUploading(true);
        setFile(file);
        setShow(false);
        setUploaded({});
        const resp = await uploadImage(file);
        handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

        if (resp.status === 200) {
          const {hash, fileName} = resp.data;
          const {projectId, _id} = doc;

          const sendingToDocumentation = await createDocument({
            fileHash: hash,
            fileName,
            projectId: projectId._id,
            documentationId: _id
          });

          if (sendingToDocumentation.status === 200) {
            setUploaded({hash, fileName});
            setUploadedFiles((prev: any) => [
              ...prev,
              sendingToDocumentation.data.data
            ]);
            setActiveLink(window.location.origin + '/file/' + resp.data.hash);
            toast('File successfully uploaded');
            setShow(true);
            setUploading(false);
          }
        } else {
          setShow(false);
          setUploading(false);
          toast.error('Something went wrong while uploading file!');
        }
      }
    };


    return (
      <>
        {uploading ? (
          <label className="btn btn-default">Uploading..</label>
        ) : (
          <label className="btn btn-default mb-0">
            <i className="fas fa-upload mr-2"></i> File Upload{' '}
            <input onChange={uploadDoc} type="file" hidden />
          </label>
        )}

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title> heading</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="input-group w-60">
              <input
                type="text"
                className="form-control"
                value={activeLink}
                disabled
              />
              <CopyToClipboard
                text={activeLink}
                onCopy={() => toast('Link Copied!')}
              >
                <button type="button" className="btn btn-secondary">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-clipboard"
                    viewBox="0 0 16 16"
                  >
                    <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"></path>
                    <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"></path>
                  </svg>
                </button>
              </CopyToClipboard>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
              close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  const validate = (values: any) => {
    return {};
  };

  const onSubmit = async (values: any) => {
    if (docName === '') {
      toast.error('Please enter document name');
      return;
    }

    if (doc === '') {
      toast.error('Please enter content in the doc');
      return;
    }

    if (Object.keys(selectedProject).length === 0) {
      toast.error('Please select project Name');
      return;
    }

    const updateDocument = await updateDoc({
      documentationName: docName,
      text: docContent,
      projectId: selectedProject.value,
      docId: doc._id
    });
    handleStatus(updateDocument.status, () => dispatch(logoutUser()), navigate);

    if (updateDocument.status === 200) {
      toast.success('Document Updated Successfully');
      navigate('/view-doc/' + doc._id);
    }
  };

  const formik = useFormik({
    initialValues: {
      docName: ''
    },
    enableReinitialize: true,
    validate,
    onSubmit
  });

  const getDocInfoFn = async () => {
    setShowLoader(true);

    const res = await getDocInfo(docId);
    handleStatus(res.status, () => dispatch(logoutUser()), navigate);

    if (res.data.ok) {
      setDoc(res.data.data);

      setSelectedProject({
        value: res.data.data.projectId._id,
        label: res.data.data.projectId.projectName
      });
      setShowLoader(false);
    } else {
      setShowLoader(false);
    }
  };

  const getAllFiles = async (docId: any) => {
    const files = await getDocFiles(docId);
    handleStatus(files.status, () => dispatch(logoutUser()), navigate);

    if (files.status === 200 && files.data.ok) {
      setUploadedFiles(files.data.data);
    }
  };

  useEffect(() => {
    getDocInfoFn();
    getAllFiles(docId);
  }, []);

  useEffect(() => {
    getAllFiles(docId);
  }, [reload]);

  useEffect(() => {
    const projectInfo = allProject.find(
      (project) => project.value === doc.projectId
    );
    setProject(projectInfo);
    setDocName(doc.documentationName);
    // setDocContent(doc.text);
  }, [doc]);

  if (showLoader) {
    return <Loader title={'Daily'} />;
  }

  const navigateBack = () => {
    navigate(-1);
  };

  const getIcon = (file: any) => {
    const {fileName} = file;
    const extention = fileName.split('.')[1];

    if (extention === 'png' || extention === 'jpg' || extention === 'jpeg') {
      return (
        <MdImage
          style={{
            height: '100px',
            width: '100px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (extention === 'gif') {
      return (
        <MdGif
          style={{
            height: '100px',
            width: '100px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (extention === 'mp3') {
      return (
        <MdAudioFile
          style={{
            height: '100px',
            width: '100px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (extention === 'pm4' || extention === 'pdf') {
      return (
        <TbPdf
          style={{
            height: '100px',
            width: '100px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (extention === 'xls') {
      return (
        <BsFileExcel
          style={{
            height: '100px',
            width: '100px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (extention === 'csv') {
      return (
        <BsFiletypeCsv
          style={{
            height: '100px',
            width: '100px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (extention === 'zip') {
      return (
        <BsFileZip
          style={{
            height: '100px',
            width: '100px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }

    if (extention === 'docx') {
      return (
        <BsFiletypeDocx
          style={{
            height: '100px',
            width: '100px',
            margin: '8px',
            color: '#17a2b8'
          }}
        />
      );
    }
  };

  const removeHandler = async (fileId: any) => {
    const resp = await fileDeleteHandler(fileId);
    handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

    if (resp.data.ok) {
      const newArr = [...uploadedFiles];
      const filtered = newArr.filter((file) => file._id !== fileId);
    
      setUploadedFiles(filtered);
      toast.success('file removed successfully.');
    }
  };

  return (
    <React.Fragment>
      <ContentHeader title="Update Documentation" path={`/view-project/${doc?.projectId?._id}`} />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Update Documentation</h3>
              <Link
                to="#"
                onClick={navigateBack}
                className="d-flex align-item-center justify-content-end"
              >
                Back
              </Link>
            </div>
            <div className="card-body">
              <form onSubmit={formik.handleSubmit}>
                <div className="col-12">
                  <div className="card">
                    <div className="card-header d-flex align-items-baseline justify-content-between">
                      <h3 className="card-title card-width">Update</h3>
                      <div className="offset-4">
                        <ModalPopup />
                      </div>
                    </div>

                    <section className="content">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="card-body">
                            <div className="form-group row">
                              <label
                                htmlFor="documentName"
                                className="col-sm-2 col-form-label"
                              >
                                Document Name
                              </label>
                              <div className="col-sm-6">
                                <input
                                  name="docName"
                                  type="text"
                                  className="form-control"
                                  id="documentName"
                                  placeholder="Document Name"
                                  onChange={(e) => setDocName(e.target.value)}
                                  value={docName}
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <label
                                htmlFor="inputSkills"
                                className="col-sm-2 col-form-label"
                              >
                                Project Name
                              </label>
                              <div className="col-sm-6">
                                <Select
                                  closeMenuOnSelect={false}
                                  components={animatedComponents}
                                  defaultValue={project}
                                  value={selectedProject}
                                  onChange={(e) => setSelectedProject(e)}
                                  options={allProject}
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <div className="docs-section">
                                <Editor
                                  value={doc.text}
                                  onChange={setDocContent}
                                />
                              </div>
                            </div>

                            <div className="d-flex  flex-column">
                              <p>Attachments</p>

                              <div className="d-flex flex-row flex-wrap">
                                {uploadedFiles.length > 0 &&
                                  uploadedFiles.map((file, idx) => (
                                    <div
                                      key={idx}
                                      className="flex flex-column align-items-center justify-content-center"
                                    >
                                      {getIcon(file)}
                                      <span className="d-flex justify-content-center align-items-center">
                                        <MdOutlineClose
                                          onClick={() =>
                                            removeHandler(file._id)
                                          }
                                          title="Remove"
                                          style={{
                                            height: '25px',
                                            width: '25px',
                                            margin: '10px',
                                            cursor: 'pointer'
                                          }}
                                        />
                                        <ViewDocFile fileHash={file.fileHash} />
                                        {/* <CopyToClipboard
                                          text={file.fileHash}
                                          onCopy={() => toast('Link Copied!')}
                                        >
                                          <button
                                            type="button"
                                            className="btn btn-secondary open-external-link"
                                          >
                                           <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 128 128" width="64px" height="64px"><path d="M 84 11 C 82.3 11 81 12.3 81 14 C 81 15.7 82.3 17 84 17 L 106.80078 17 L 60.400391 63.400391 C 59.200391 64.600391 59.200391 66.499609 60.400391 67.599609 C 61.000391 68.199609 61.8 68.5 62.5 68.5 C 63.2 68.5 63.999609 68.199609 64.599609 67.599609 L 111 21.199219 L 111 44 C 111 45.7 112.3 47 114 47 C 115.7 47 117 45.7 117 44 L 117 14 C 117 12.3 115.7 11 114 11 L 84 11 z M 24 31 C 16.8 31 11 36.8 11 44 L 11 104 C 11 111.2 16.8 117 24 117 L 84 117 C 91.2 117 97 111.2 97 104 L 97 59 C 97 57.3 95.7 56 94 56 C 92.3 56 91 57.3 91 59 L 91 104 C 91 107.9 87.9 111 84 111 L 24 111 C 20.1 111 17 107.9 17 104 L 17 44 C 17 40.1 20.1 37 24 37 L 69 37 C 70.7 37 72 35.7 72 34 C 72 32.3 70.7 31 69 31 L 24 31 z"/></svg>
                                          </button>
                                        </CopyToClipboard> */}
                                      </span>
                                      <p className="text-center">
                                        {file.fileName.substring(0, 8) + '...'}
                                      </p>
                                    </div>
                                  ))}
                              </div>
                            </div>

                            <div className="form-group row">
                              <button
                                disabled={uploading ? true : false}
                                type="submit"
                                className="btn btn-primary"
                              >
                                Update Document
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default UpdateDoc;
